import { render, staticRenderFns } from "./gkTestA.vue?vue&type=template&id=6f9d5128&scoped=true&"
import script from "./gkTestA.vue?vue&type=script&lang=js&"
export * from "./gkTestA.vue?vue&type=script&lang=js&"
import style0 from "./gkTestA.vue?vue&type=style&index=0&id=6f9d5128&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9d5128",
  null
  
)

export default component.exports